(function(){
  var canTagWidgets = false;
  var WIDGET_SELECTOR = [
    '[id*="qstomy" i]',
    '[class*="qstomy" i]',
    'iframe[src*="qstomy" i]',
    'iframe[title*="qstomy" i]'
  ].join(',');

  function isProductPage(){
    return document.body.classList.contains('template-product') ||
      window.location.pathname.indexOf('/products/') === 0;
  }

  function findFloatingRoot(node){
    var current = node;
    while(current && current !== document.body && current !== document.documentElement){
      var style = window.getComputedStyle(current);
      if(style.position === 'fixed' || style.position === 'sticky'){
        return current;
      }
      current = current.parentElement;
    }
    return null;
  }

  function tagQstomyWidgets(){
    if(!canTagWidgets) return;
    document.querySelectorAll(WIDGET_SELECTOR).forEach(function(node){
      var root = findFloatingRoot(node);
      if(!root || root === document.documentElement) return;
      root.classList.add('ma-qstomy-widget');
      if(root.style.left !== 'var(--ma-qstomy-left)') root.style.left = 'var(--ma-qstomy-left)';
      if(root.style.right !== 'auto') root.style.right = 'auto';
      if(root.style.bottom !== 'calc(var(--ma-qstomy-bottom) + env(safe-area-inset-bottom, 0px))'){
        root.style.bottom = 'calc(var(--ma-qstomy-bottom) + env(safe-area-inset-bottom, 0px))';
      }
      if(root.style.zIndex !== '45') root.style.zIndex = '45';

      if(node.tagName === 'IFRAME' && !node.getAttribute('title')){
        node.setAttribute('title', 'Chat Maison Atmosia');
      }
      if(!root.getAttribute('aria-label') && /^(button|a)$/i.test(root.tagName)){
        root.setAttribute('aria-label', 'Ouvrir le chat Maison Atmosia');
      }
    });
  }

  function updateOverlayState(){
    var menuOpen = !!document.querySelector(
      '.ma-mobile-menu[data-state="open"], [data-instant-type="overlay"][data-state="open"], header-drawer details[open], header-drawer details.menu-opening, #Details-menu-drawer-container[open], .menu-drawer-container[open]'
    );
    var cartDrawer = document.querySelector('cart-drawer');
    var cartOpen = !!document.querySelector('cart-drawer.active, cart-drawer[open], cart-drawer.drawer--is-open, #CartDrawer.active, #CartDrawer.drawer--is-open, .cart-drawer.active, .drawer.active') ||
      !!(cartDrawer && cartDrawer.classList.contains('active'));
    document.body.classList.toggle('ma-overlay-open', menuOpen);
    document.body.classList.toggle('ma-cart-open', cartOpen);
    document.body.classList.toggle('ma-product-page', isProductPage());
  }

  function refresh(){
    tagQstomyWidgets();
    updateOverlayState();
  }

  function scheduleRefresh(delay){
    window.clearTimeout(window.__maQstomyRefresh);
    window.__maQstomyRefresh = window.setTimeout(refresh, delay);
  }

  function enableWidgetTagging(){
    canTagWidgets = true;
    scheduleRefresh(500);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', updateOverlayState);
  } else {
    updateOverlayState();
  }

  window.addEventListener('load', function(){
    updateOverlayState();
    window.setTimeout(enableWidgetTagging, 2500);
  });
  document.addEventListener('click', function(){
    window.setTimeout(updateOverlayState, 60);
    scheduleRefresh(canTagWidgets ? 900 : 2500);
  }, true);

  if(window.MutationObserver){
    new MutationObserver(function(){
      updateOverlayState();
      scheduleRefresh(canTagWidgets ? 900 : 2500);
    }).observe(document.documentElement, {
      childList:true,
      subtree:true,
      attributes:true,
      attributeFilter:['class','style','data-state','open']
    });
  }
})();
